import type { Skill } from 'bundles/browse/components/Domain/types/Domain';

import _t from 'i18n!nls/browse';

type subDomainPopularTopicsData = { [domainSlug: string]: Skill[] };

const getSubDomainPopularTopicsData = (): subDomainPopularTopicsData => {
  return {
    'data-analysis': [
      {
        domainId: 'data-science',
        skillId: 'microsoft-excel',
        skillName: _t('Excel'),
        skillSearchUrl: '/courses?query=microsoft%20excel',
      },
      {
        domainId: 'data-science',
        skillId: 'power-bi',
        skillName: _t('Power BI'),
        skillSearchUrl: '/courses?query=power%20bi',
      },
      {
        domainId: 'data-science',
        skillId: 'tableau',
        skillName: _t('Tableau'),
        skillSearchUrl: '/courses?query=tableau',
      },
      {
        domainId: 'data-science',
        skillId: 'data-visualization',
        skillName: _t('Data Visualization'),
        skillSearchUrl: '/courses?query=data%20visualization',
      },
      {
        domainId: 'data-science',
        skillId: 'spss',
        skillName: _t('SPSS'),
        skillSearchUrl: '/courses?query=spss',
      },
      {
        domainId: 'data-science',
        skillId: 'vba',
        skillName: _t('VBA'),
        skillSearchUrl: '/courses?query=vba',
      },
      {
        domainId: 'data-science',
        skillId: 'matlab',
        skillName: _t('MATLAB'),
        skillSearchUrl: '/courses?query=matlab',
      },
      {
        domainId: 'data-science',
        skillId: 'data-modeling',
        skillName: _t('Data Modeling'),
        skillSearchUrl: '/courses?query=data%20modeling',
      },
      {
        domainId: 'data-science',
        skillId: 'statistical-analysis',
        skillName: _t('Statistical Analysis'),
        skillSearchUrl: '/courses?query=statistical%20analysis',
      },
    ],
    'machine-learning': [
      {
        domainId: 'data-science',
        skillId: 'artificial-intelligence',
        skillName: _t('Artificial Intelligence'),
        skillSearchUrl: '/courses?query=artificial%20intelligence',
      },
      {
        domainId: 'data-science',
        skillId: 'computer-vision',
        skillName: _t('Computer Vision'),
        skillSearchUrl: '/courses?query=computer%20vision',
      },
      {
        domainId: 'data-science',
        skillId: 'deep-learning',
        skillName: _t('Deep Learning'),
        skillSearchUrl: '/courses?query=deep%20learning',
      },
      {
        domainId: 'data-science',
        skillId: 'nlp',
        skillName: _t('Natural Language Processing'),
        skillSearchUrl: '/courses?query=nlp',
      },
      {
        domainId: 'data-science',
        skillId: 'big-data',
        skillName: _t('Big Data'),
        skillSearchUrl: '/courses?query=big%20data',
      },
      {
        domainId: 'data-science',
        skillId: 'tensorflow',
        skillName: _t('Tensorflow'),
        skillSearchUrl: '/courses?query=tensorflow',
      },
      {
        domainId: 'data-science',
        skillId: 'neural-networks',
        skillName: _t('Neural Networks'),
        skillSearchUrl: '/courses?query=neural%20networks',
      },
      {
        domainId: 'data-science',
        skillId: 'numpy',
        skillName: _t('NumPy'),
        skillSearchUrl: '/courses?query=numpy',
      },
      {
        domainId: 'data-science',
        skillId: 'reinforcement-learning',
        skillName: _t('Reinforcement Learning'),
        skillSearchUrl: '/courses?query=reinforcement%20learning',
      },
    ],
    'probability-and-statistics': [
      {
        domainId: 'data-science',
        skillId: 'statistics-for-data-science',
        skillName: _t('Statistics For Data Science'),
        skillSearchUrl: '/courses?query=statistics%20for%20data%20science',
      },
      {
        domainId: 'data-science',
        skillId: 'causal-inference',
        skillName: _t('Causal Inference'),
        skillSearchUrl: '/courses?query=causal%20inference',
      },
      {
        domainId: 'data-science',
        skillId: 'data-mining',
        skillName: _t('Data Mining'),
        skillSearchUrl: '/courses?query=data%20mining',
      },
      {
        domainId: 'data-science',
        skillId: 'probability-theory',
        skillName: _t('Probability Theory'),
        skillSearchUrl: '/courses?query=probability%20theory',
      },
      {
        domainId: 'data-science',
        skillId: 'advanced-statistics',
        skillName: _t('Advanced Statistics'),
        skillSearchUrl: '/courses?query=advanced%20statistics',
      },
      {
        domainId: 'data-science',
        skillId: 'bayesian-statistics',
        skillName: _t('Bayesian Statistics'),
        skillSearchUrl: '/courses?query=bayesian%20statistics',
      },
      {
        domainId: 'data-science',
        skillId: 'regression-analysis',
        skillName: _t('Regression Analysis'),
        skillSearchUrl: '/courses?query=regression%20analysis',
      },
      {
        domainId: 'data-science',
        skillId: 'applied-statistics',
        skillName: _t('Applied Statistics'),
        skillSearchUrl: '/courses?query=applied%20statistics',
      },
    ],
    finance: [
      {
        domainId: 'business',
        skillId: 'stock-market',
        skillName: _t('Stock Market'),
        skillSearchUrl: '/courses?query=stock%20market',
      },
      {
        domainId: 'business',
        skillId: 'accounting',
        skillName: _t('Accounting'),
        skillSearchUrl: '/courses?query=accounting',
      },
      {
        domainId: 'business',
        skillId: 'investment',
        skillName: _t('Investment'),
        skillSearchUrl: '/courses?query=investment',
      },
      {
        domainId: 'business',
        skillId: 'financial-modeling',
        skillName: _t('Financial Modeling'),
        skillSearchUrl: '/courses?query=financial%20modeling',
      },
      {
        domainId: 'business',
        skillId: 'trading',
        skillName: _t('Trading'),
        skillSearchUrl: '/courses?query=trading',
      },
      {
        domainId: 'business',
        skillId: 'fintech',
        skillName: _t('Fintech'),
        skillSearchUrl: '/courses?query=fintech',
      },
      {
        domainId: 'business',
        skillId: 'financial-analysis',
        skillName: _t('Financial Analysis'),
        skillSearchUrl: '/courses?query=financial%20analysis',
      },
      {
        domainId: 'business',
        skillId: 'quantitative-finance',
        skillName: _t('Quantitative Finance'),
        skillSearchUrl: '/courses?query=quantitative%20finance',
      },
      {
        domainId: 'business',
        skillId: 'personal-finance',
        skillName: _t('Personal Finance'),
        skillSearchUrl: '/courses?query=personal%20finance',
      },
    ],
    marketing: [
      {
        domainId: 'business',
        skillId: 'market-research',
        skillName: _t('Market Research'),
        skillSearchUrl: '/courses?query=market%20research',
      },
      {
        domainId: 'business',
        skillId: 'digital-marketing',
        skillName: _t('Digital Marketing'),
        skillSearchUrl: '/courses?query=digital%20marketing',
      },
      {
        domainId: 'business',
        skillId: 'branding',
        skillName: _t('Branding'),
        skillSearchUrl: '/courses?query=branding',
      },
      {
        domainId: 'business',
        skillId: 'brand-management',
        skillName: _t('Brand Management'),
        skillSearchUrl: '/courses?query=brand%20management',
      },
      {
        domainId: 'business',
        skillId: 'advertising',
        skillName: _t('Advertising'),
        skillSearchUrl: '/courses?query=advertising',
      },
      {
        domainId: 'business',
        skillId: 'social-media-marketing',
        skillName: _t('Social Media Marketing'),
        skillSearchUrl: '/courses?query=social%20media%20marketing',
      },
      {
        domainId: 'business',
        skillId: 'marketing-analytics',
        skillName: _t('Marketing Analytics'),
        skillSearchUrl: '/courses?query=marketing%20analytics',
      },
    ],
    'leadership-and-management': [
      {
        domainId: 'business',
        skillId: 'six-sigma',
        skillName: _t('Six Sigma'),
        skillSearchUrl: '/courses?query=six%20sigma',
      },
      {
        domainId: 'business',
        skillId: 'business-management',
        skillName: _t('Business Management'),
        skillSearchUrl: '/courses?query=business%20management',
      },
      {
        domainId: 'business',
        skillId: 'business-communication',
        skillName: _t('Business Communication'),
        skillSearchUrl: '/courses?query=business%20communication',
      },
      {
        domainId: 'business',
        skillId: 'change-management',
        skillName: _t('Change Management'),
        skillSearchUrl: '/courses?query=change%20management',
      },
      {
        domainId: 'business',
        skillId: 'human-resource-management',
        skillName: _t('Human Resource Management'),
        skillSearchUrl: '/courses?query=human%20resource%20management',
      },
      {
        domainId: 'business',
        skillId: 'digital-transformation',
        skillName: _t('Digital Transformation'),
        skillSearchUrl: '/courses?query=digital%20transformation',
      },
      {
        domainId: 'business',
        skillId: 'business-administration',
        skillName: _t('Business Administration'),
        skillSearchUrl: '/courses?query=business%20administration',
      },
      {
        domainId: 'business',
        skillId: 'decision-making',
        skillName: _t('Decision Making'),
        skillSearchUrl: '/courses?query=decision%20making',
      },
      {
        domainId: 'business',
        skillId: 'organizational-development',
        skillName: _t('Organizational Development'),
        skillSearchUrl: '/courses?query=organizational%20development',
      },
      {
        domainId: 'business',
        skillId: 'people-management',
        skillName: _t('People Management'),
        skillSearchUrl: '/courses?query=people%20management',
      },
    ],
    entrepreneurship: [
      {
        domainId: 'business',
        skillId: 'time-management',
        skillName: _t('Time Management'),
        skillSearchUrl: '/courses?query=time%20management',
      },
      {
        domainId: 'business',
        skillId: 'financial-accounting',
        skillName: _t('Financial Accounting'),
        skillSearchUrl: '/courses?query=financial%20accounting',
      },
      {
        domainId: 'business',
        skillId: 'venture-capital',
        skillName: _t('Venture Capital'),
        skillSearchUrl: '/courses?query=venture%20capital',
      },
      {
        domainId: 'business',
        skillId: 'recruitment',
        skillName: _t('Recruitment'),
        skillSearchUrl: '/courses?query=recruitment',
      },
      {
        domainId: 'business',
        skillId: 'consumer-behavior',
        skillName: _t('Consumer Behavior'),
        skillSearchUrl: '/courses?query=consumer%20behavior',
      },
      {
        domainId: 'business',
        skillId: 'nonprofit',
        skillName: _t('Nonprofit'),
        skillSearchUrl: '/courses?query=nonprofit',
      },
      {
        domainId: 'business',
        skillId: 'leadership',
        skillName: _t('Leadership'),
        skillSearchUrl: '/courses?query=leadership',
      },
      {
        domainId: 'business',
        skillId: 'fundraising',
        skillName: _t('Fundraising'),
        skillSearchUrl: '/courses?query=fundraising',
      },
      {
        domainId: 'business',
        skillId: 'pricing-strategy',
        skillName: _t('Pricing Strategy'),
        skillSearchUrl: '/courses?query=pricing%20strategy',
      },
    ],
    'business-essentials': [
      {
        domainId: 'business',
        skillId: 'negotiation',
        skillName: _t('Negotiation'),
        skillSearchUrl: '/courses?query=negotiation',
      },
      {
        domainId: 'business',
        skillId: 'financial-planning',
        skillName: _t('Financial Planning'),
        skillSearchUrl: '/courses?query=financial%20planning',
      },
      {
        domainId: 'business',
        skillId: 'stock-trading',
        skillName: _t('Stock Trading'),
        skillSearchUrl: '/courses?query=stock%20trading',
      },
      {
        domainId: 'business',
        skillId: 'supply-chain-analytics',
        skillName: _t('Supply Chain Analytics'),
        skillSearchUrl: '/courses?query=supply%20chain%20analytics',
      },
      {
        domainId: 'business',
        skillId: 'public-relations',
        skillName: _t('Public Relations'),
        skillSearchUrl: '/courses?query=public%20relations',
      },
      {
        domainId: 'business',
        skillId: 'asset-management',
        skillName: _t('Asset Management'),
        skillSearchUrl: '/courses?query=asset%20management',
      },
      {
        domainId: 'business',
        skillId: 'international-business',
        skillName: _t('International Business'),
        skillSearchUrl: '/courses?query=international%20business',
      },
      {
        domainId: 'business',
        skillId: 'process-improvement',
        skillName: _t('Process Improvement'),
        skillSearchUrl: '/courses?query=process%20improvement',
      },
      {
        domainId: 'business',
        skillId: 'management',
        skillName: _t('Management'),
        skillSearchUrl: '/courses?query=management',
      },
    ],
    'business-strategy': [
      {
        domainId: 'business',
        skillId: 'mergers-and-acquisitions',
        skillName: _t('Mergers and Acquisitions'),
        skillSearchUrl: '/courses?query=mergers%20and%20acquisitions',
      },
      {
        domainId: 'business',
        skillId: 'procurement',
        skillName: _t('Procurement'),
        skillSearchUrl: '/courses?query=procurement',
      },
      {
        domainId: 'business',
        skillId: 'hr-analytics',
        skillName: _t('HR Analytics'),
        skillSearchUrl: '/courses?query=hr%20analytics',
      },
      {
        domainId: 'business',
        skillId: 'international-trade',
        skillName: _t('International Trade'),
        skillSearchUrl: '/courses?query=international%20trade',
      },
      {
        domainId: 'business',
        skillId: 'strategic-planning',
        skillName: _t('Strategic Planning'),
        skillSearchUrl: '/courses?query=strategic%20planning',
      },
      {
        domainId: 'business',
        skillId: 'business-law',
        skillName: _t('Business Law'),
        skillSearchUrl: '/courses?query=business%20law',
      },
      {
        domainId: 'business',
        skillId: 'business-plan',
        skillName: _t('Business Plan'),
        skillSearchUrl: '/courses?query=business%20plan',
      },
    ],
    'mobile-and-web-development': [
      {
        domainId: 'computer-science',
        skillId: 'web-development',
        skillName: _t('Web Development'),
        skillSearchUrl: '/courses?query=web%20development',
      },
      {
        domainId: 'computer-science',
        skillId: 'full-stack-web-development',
        skillName: _t('Full Stack Web Development'),
        skillSearchUrl: '/courses?query=full%20stack%20web%20development',
      },
      {
        domainId: 'computer-science',
        skillId: 'mobile-app-development',
        skillName: _t('Mobile App Development'),
        skillSearchUrl: '/courses?query=mobile%20app%20development',
      },
      {
        domainId: 'computer-science',
        skillId: 'javascript',
        skillName: _t('JavaScript'),
        skillSearchUrl: '/courses?query=javascript',
      },
      {
        domainId: 'computer-science',
        skillId: 'android-app-development',
        skillName: _t('Android App Development'),
        skillSearchUrl: '/courses?query=android%20app%20development',
      },
      {
        domainId: 'computer-science',
        skillId: 'html',
        skillName: _t('HTML'),
        skillSearchUrl: '/courses?query=html',
      },
      {
        domainId: 'computer-science',
        skillId: 'front-end',
        skillName: _t('Front End Development'),
        skillSearchUrl: '/courses?query=front%20end',
      },
      {
        domainId: 'computer-science',
        skillId: 'css',
        skillName: _t('CSS'),
        skillSearchUrl: '/courses?query=css',
      },
      {
        domainId: 'computer-science',
        skillId: 'web-design',
        skillName: _t('Web Design'),
        skillSearchUrl: '/courses?query=web%20design',
      },
    ],
    algorithms: [
      {
        domainId: 'computer-science',
        skillId: 'data-structures-and-algorithms',
        skillName: _t('Data Structures and Algorithms'),
        skillSearchUrl: '/courses?query=data%20structures%20and%20algorithms',
      },
      {
        domainId: 'computer-science',
        skillId: 'automation',
        skillName: _t('Automation'),
        skillSearchUrl: '/courses?query=automation',
      },
      {
        domainId: 'computer-science',
        skillId: 'computer-programming',
        skillName: _t('Computer Programming'),
        skillSearchUrl: '/courses?query=computer%20programming',
      },
      {
        domainId: 'computer-science',
        skillId: 'optimization',
        skillName: _t('Optimization'),
        skillSearchUrl: '/courses?query=optimization',
      },
    ],
    'design-and-product': [
      {
        domainId: 'computer-science',
        skillId: 'scrum',
        skillName: _t('Scrum'),
        skillSearchUrl: '/courses?query=scrum',
      },
      {
        domainId: 'computer-science',
        skillId: 'human-computer-interaction',
        skillName: _t('Human Computer Interaction'),
        skillSearchUrl: '/courses?query=human%20computer%20interaction',
      },
      {
        domainId: 'computer-science',
        skillId: 'ux-research',
        skillName: _t('UX Research'),
        skillSearchUrl: '/courses?query=ux%20research',
      },
      {
        domainId: 'computer-science',
        skillId: 'computer-graphics',
        skillName: _t('Computer Graphics'),
        skillSearchUrl: '/courses?query=computer%20graphics',
      },
      {
        domainId: 'computer-science',
        skillId: 'app-design',
        skillName: _t('App Design'),
        skillSearchUrl: '/courses?query=app%20design',
      },
      {
        domainId: 'computer-science',
        skillId: 'design-patterns',
        skillName: _t('Design Patterns'),
        skillSearchUrl: '/courses?query=design%20patterns',
      },
      {
        domainId: 'computer-science',
        skillId: 'virtual-reality',
        skillName: _t('Virtual Reality'),
        skillSearchUrl: '/courses?query=virtual%20reality',
      },
    ],
    'cloud-computing': [
      {
        domainId: 'information-technology',
        skillId: 'cloud-computing-applications',
        skillName: _t('Cloud Computing Applications'),
        skillSearchUrl: '/courses?query=cloud%20computing%20applications',
      },
      {
        domainId: 'information-technology',
        skillId: 'microsoft-azure',
        skillName: _t('Microsoft Azure'),
        skillSearchUrl: '/courses?query=microsoft%20azure',
      },
      {
        domainId: 'information-technology',
        skillId: 'computer-programming',
        skillName: _t('AWS'),
        skillSearchUrl: '/courses?query=aws',
      },
      {
        domainId: 'information-technology',
        skillId: 'kubernetes',
        skillName: _t('Kubernetes'),
        skillSearchUrl: '/courses?query=kubernetes',
      },
    ],
    security: [
      {
        domainId: 'information-technology',
        skillId: 'cybersecurity',
        skillName: _t('Cybersecurity'),
        skillSearchUrl: '/courses?query=cybersecurity',
      },
      {
        domainId: 'information-technology',
        skillId: 'data-security',
        skillName: _t('Data Security'),
        skillSearchUrl: '/courses?query=data%20security',
      },
      {
        domainId: 'information-technology',
        skillId: 'software-security',
        skillName: _t('Software Security'),
        skillSearchUrl: '/courses?query=software%20security',
      },
      {
        domainId: 'information-technology',
        skillId: 'internet-security',
        skillName: _t('Internet Security'),
        skillSearchUrl: '/courses?query=internet%20security',
      },
      {
        domainId: 'information-technology',
        skillId: 'network-security',
        skillName: _t('Network Security'),
        skillSearchUrl: '/courses?query=network%20security',
      },
    ],
    'software-development': [
      {
        domainId: 'computer-science',
        skillId: 'java',
        skillName: _t('Java'),
        skillSearchUrl: '/courses?query=java',
      },
      {
        domainId: 'computer-science',
        skillId: 'c%2B%2B',
        skillName: _t('C++'),
        skillSearchUrl: '/courses?query=c%2B%2B',
      },
      {
        domainId: 'computer-science',
        skillId: 'c-programming',
        skillName: _t('C Programming'),
        skillSearchUrl: '/courses?query=c%20programming',
      },
      {
        domainId: 'computer-science',
        skillId: 'software-engineering',
        skillName: _t('Software Engineering'),
        skillSearchUrl: '/courses?query=software%20engineering',
      },
      {
        domainId: 'computer-science',
        skillId: 'software-testing',
        skillName: _t('Software Testing'),
        skillSearchUrl: '/courses?query=software%20testing',
      },
      {
        domainId: 'computer-science',
        skillId: 'iot',
        skillName: _t('Internet of Things (IoT)'),
        skillSearchUrl: '/courses?query=iot',
      },
      {
        domainId: 'computer-science',
        skillId: 'embedded-systems',
        skillName: _t('Embedded Systems'),
        skillSearchUrl: '/courses?query=embedded%20systems',
      },
      {
        domainId: 'computer-science',
        skillId: 'programming',
        skillName: _t('Programming'),
        skillSearchUrl: '/courses?query=programming',
      },
      {
        domainId: 'computer-science',
        skillId: 'kubernetes',
        skillName: _t('Kubernetes'),
        skillSearchUrl: '/courses?query=kubernetes',
      },
      {
        domainId: 'computer-science',
        skillId: 'object-oriented-programming',
        skillName: _t('Object Oriented Programming'),
        skillSearchUrl: '/courses?query=object%20oriented%20programming',
      },
    ],
    history: [
      {
        domainId: 'arts-and-humanities',
        skillId: 'archaeology',
        skillName: _t('Archaeology'),
        skillSearchUrl: '/courses?query=archaeology',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'greek-mythology',
        skillName: _t('Greek Mythology'),
        skillSearchUrl: '/courses?query=greek%20mythology',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'world-history',
        skillName: _t('World History'),
        skillSearchUrl: '/courses?query=world%20history',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'ancient-history',
        skillName: _t('Ancient History'),
        skillSearchUrl: '/courses?query=ancient%20history',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'american-history',
        skillName: _t('American History'),
        skillSearchUrl: '/courses?query=american%20history',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'middle-east',
        skillName: _t('Middle East'),
        skillSearchUrl: '/courses?query=middle%20east',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'medieval-europe',
        skillName: _t('Medieval Europe'),
        skillSearchUrl: '/courses?query=medieval%20europe',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'mythology',
        skillName: _t('Mythology'),
        skillSearchUrl: '/courses?query=mythology',
      },
    ],
    'music-and-art': [
      {
        domainId: 'arts-and-humanities',
        skillId: 'piano',
        skillName: _t('Piano'),
        skillSearchUrl: '/courses?query=piano',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'sound-design',
        skillName: _t('Sound Design'),
        skillSearchUrl: '/courses?query=sound%20design',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'poetry',
        skillName: _t('Poetry'),
        skillSearchUrl: '/courses?query=poetry',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'graphic-design',
        skillName: _t('Graphic Design'),
        skillSearchUrl: '/courses?query=graphic%20design',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'literature',
        skillName: _t('Literature'),
        skillSearchUrl: '/courses?query=literature',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'creative-writing"',
        skillName: _t('Creative Writing"'),
        skillSearchUrl: '/courses?query=creative%20writing"',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'guitar',
        skillName: _t('Guitar'),
        skillSearchUrl: '/courses?query=guitar',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'music-business',
        skillName: _t('Music Business'),
        skillSearchUrl: '/courses?query=music%20business',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'music-production',
        skillName: _t('Music Production'),
        skillSearchUrl: '/courses?query=music%20production',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'jazz',
        skillName: _t('Jazz'),
        skillSearchUrl: '/courses?query=jazz',
      },
    ],
    philosophy: [
      {
        domainId: 'arts-and-humanities',
        skillId: 'buddhism',
        skillName: _t('Buddhism'),
        skillSearchUrl: '/courses?query=buddhism',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'religion',
        skillName: _t('Religion'),
        skillSearchUrl: '/courses?query=religion',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'logic',
        skillName: _t('Logic'),
        skillSearchUrl: '/courses?query=logic',
      },
      {
        domainId: 'arts-and-humanities',
        skillId: 'ancient-philosophy',
        skillName: _t('Ancient Philosophy'),
        skillSearchUrl: '/courses?query=ancient%20philosophy',
      },
    ],
    'animal-health': [
      {
        domainId: 'life-sciences',
        skillId: 'biology',
        skillName: _t('Biology'),
        skillSearchUrl: '/courses?query=biology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'veterinary',
        skillName: _t('Veterinary'),
        skillSearchUrl: '/courses?query=veterinary',
      },
      {
        domainId: 'life-sciences',
        skillId: 'animal-behavior',
        skillName: _t('Animal Behavior'),
        skillSearchUrl: '/courses?query=animal%20behavior',
      },
      {
        domainId: 'life-sciences',
        skillId: 'marine-biology',
        skillName: _t('Marine Biology'),
        skillSearchUrl: '/courses?query=marine%20biology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'zoology',
        skillName: _t('Zoology'),
        skillSearchUrl: '/courses?query=zoology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'evolution',
        skillName: _t('Evolution'),
        skillSearchUrl: '/courses?query=evolution',
      },
    ],
    'basic-science': [
      {
        domainId: 'life-sciences',
        skillId: 'agriculture',
        skillName: _t('Agriculture'),
        skillSearchUrl: '/courses?query=agriculture',
      },
      {
        domainId: 'life-sciences',
        skillId: 'botany',
        skillName: _t('Botany'),
        skillSearchUrl: '/courses?query=botany',
      },
      {
        domainId: 'life-sciences',
        skillId: 'genetics',
        skillName: _t('Genetics'),
        skillSearchUrl: '/courses?query=genetics',
      },
      {
        domainId: 'life-sciences',
        skillId: 'immunology',
        skillName: _t('Immunology'),
        skillSearchUrl: '/courses?query=immunology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'biochemistry',
        skillName: _t('Biochemistry'),
        skillSearchUrl: '/courses?query=biochemistry',
      },
      {
        domainId: 'life-sciences',
        skillId: 'pharmacology',
        skillName: _t('Pharmacology'),
        skillSearchUrl: '/courses?query=pharmacology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'paleontology',
        skillName: _t('Paleontology'),
        skillSearchUrl: '/courses?query=paleontology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'ecology',
        skillName: _t('Ecology'),
        skillSearchUrl: '/courses?query=ecology',
      },
    ],
    'health-informatics': [
      {
        domainId: 'life-sciences',
        skillId: 'biotechnology',
        skillName: _t('Biotechnology'),
        skillSearchUrl: '/courses?query=biotechnology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'healthcare-data-analytics',
        skillName: _t('Healthcare Data Analytics'),
        skillSearchUrl: '/courses?query=healthcare%20data%20analytics',
      },
      {
        domainId: 'life-sciences',
        skillId: 'bioinformatics',
        skillName: _t('Bioinformatics'),
        skillSearchUrl: '/courses?query=bioinformatics',
      },
      {
        domainId: 'life-sciences',
        skillId: 'genome-sequencing',
        skillName: _t('Genome Sequencing'),
        skillSearchUrl: '/courses?query=genome%20sequencing',
      },
      {
        domainId: 'life-sciences',
        skillId: 'medical-statistics',
        skillName: _t('Medical Statistics'),
        skillSearchUrl: '/courses?query=medical%20statistics',
      },
    ],
    nutrition: [
      {
        domainId: 'life-sciences',
        skillId: 'food-science',
        skillName: _t('Food Science'),
        skillSearchUrl: '/courses?query=food%20science',
      },
      {
        domainId: 'life-sciences',
        skillId: 'cooking',
        skillName: _t('Cooking'),
        skillSearchUrl: '/courses?query=cooking',
      },
      {
        domainId: 'life-sciences',
        skillId: 'food',
        skillName: _t('Food'),
        skillSearchUrl: '/courses?query=food',
      },
      {
        domainId: 'life-sciences',
        skillId: 'diet',
        skillName: _t('Diet'),
        skillSearchUrl: '/courses?query=diet',
      },
    ],
    'patient-care': [
      {
        domainId: 'life-sciences',
        skillId: 'physical-therapy',
        skillName: _t('Physical Therapy'),
        skillSearchUrl: '/courses?query=physical%20therapy',
      },
      {
        domainId: 'life-sciences',
        skillId: 'herbal-medicine',
        skillName: _t('Herbal Medicine'),
        skillSearchUrl: '/courses?query=herbal%20medicine',
      },
      {
        domainId: 'life-sciences',
        skillId: 'nursing',
        skillName: _t('Nursing'),
        skillSearchUrl: '/courses?query=nursing',
      },
      {
        domainId: 'life-sciences',
        skillId: 'pediatrics',
        skillName: _t('Pediatrics'),
        skillSearchUrl: '/courses?query=pediatrics',
      },
      {
        domainId: 'life-sciences',
        skillId: 'first-aid',
        skillName: _t('First Aid'),
        skillSearchUrl: '/courses?query=first%20aid',
      },
    ],
    'public-health': [
      {
        domainId: 'life-sciences',
        skillId: 'epidemiology',
        skillName: _t('Epidemiology'),
        skillSearchUrl: '/courses?query=epidemiology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'health-policy',
        skillName: _t('Health Policy'),
        skillSearchUrl: '/courses?query=health%20policy',
      },
      {
        domainId: 'life-sciences',
        skillId: 'healthcare-analytics',
        skillName: _t('Healthcare Analytics'),
        skillSearchUrl: '/courses?query=healthcare%20analytics',
      },
      {
        domainId: 'life-sciences',
        skillId: 'infectious-disease',
        skillName: _t('Infectious Disease'),
        skillSearchUrl: '/courses?query=infectious%20disease',
      },
      {
        domainId: 'life-sciences',
        skillId: 'gender',
        skillName: _t('Gender'),
        skillSearchUrl: '/courses?query=gender',
      },
    ],
    research: [
      {
        domainId: 'life-sciences',
        skillId: 'clinical-research',
        skillName: _t('Clinical Research'),
        skillSearchUrl: '/courses?query=clinical%20research',
      },
      {
        domainId: 'life-sciences',
        skillId: 'health-policy',
        skillName: _t('Health Policy'),
        skillSearchUrl: '/courses?query=health%20policy',
      },
      {
        domainId: 'life-sciences',
        skillId: 'medical-writing',
        skillName: _t('Medical Writing'),
        skillSearchUrl: '/courses?query=medical%20writing',
      },
      {
        domainId: 'life-sciences',
        skillId: 'clinical-trials',
        skillName: _t('Clinical Trials'),
        skillSearchUrl: '/courses?query=clinical%20trials',
      },
      {
        domainId: 'life-sciences',
        skillId: 'drug-discovery',
        skillName: _t('Drug Discovery'),
        skillSearchUrl: '/courses?query=drug%20discovery',
      },
      {
        domainId: 'life-sciences',
        skillId: 'next-generation-sequencing',
        skillName: _t('Next Generation Sequencing'),
        skillSearchUrl: '/courses?query=next%20generation%20sequencing',
      },
    ],
    psychology: [
      {
        domainId: 'life-sciences',
        skillId: 'child-psychology',
        skillName: _t('Child Psychology'),
        skillSearchUrl: '/courses?query=child%20psychology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'mental-health',
        skillName: _t('Mental Health'),
        skillSearchUrl: '/courses?query=mental%20health',
      },
      {
        domainId: 'life-sciences',
        skillId: 'emotional-intelligence',
        skillName: _t('Emotional Intelligence'),
        skillSearchUrl: '/courses?query=emotional%20intelligence',
      },
      {
        domainId: 'life-sciences',
        skillId: 'clinical-psychology',
        skillName: _t('Clinical Psychology'),
        skillSearchUrl: '/courses?query=clinical%20psychology',
      },
      {
        domainId: 'life-sciences',
        skillId: 'cognitive-science',
        skillName: _t('Cognitive Science'),
        skillSearchUrl: '/courses?query=cognitive%20science',
      },
      {
        domainId: 'life-sciences',
        skillId: 'mindfulness',
        skillName: _t('Mindfulness'),
        skillSearchUrl: '/courses?query=mindfulness',
      },
      {
        domainId: 'life-sciences',
        skillId: 'therapy',
        skillName: _t('Therapy'),
        skillSearchUrl: '/courses?query=therapy',
      },
      {
        domainId: 'life-sciences',
        skillId: 'psychiatry',
        skillName: _t('Psychiatry'),
        skillSearchUrl: '/courses?query=psychiatry',
      },
      {
        domainId: 'life-sciences',
        skillId: 'happiness',
        skillName: _t('Happiness'),
        skillSearchUrl: '/courses?query=happiness',
      },
      {
        domainId: 'life-sciences',
        skillId: 'autism',
        skillName: _t('Autism'),
        skillSearchUrl: '/courses?query=autism',
      },
    ],
    'electrical-engineering': [
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'arduino',
        skillName: _t('Arduino'),
        skillSearchUrl: '/courses?query=arduino',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'circuits',
        skillName: _t('Circuits'),
        skillSearchUrl: '/courses?query=circuits',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'remote-sensing',
        skillName: _t('Remote Sensing'),
        skillSearchUrl: '/courses?query=remote%20sensing',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'nanotechnology',
        skillName: _t('Nanotechnology'),
        skillSearchUrl: '/courses?query=nanotechnology',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'battery',
        skillName: _t('Battery'),
        skillSearchUrl: '/courses?query=battery',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'semiconductor',
        skillName: _t('Semiconductor'),
        skillSearchUrl: '/courses?query=semiconductor',
      },
    ],
    'mechanical-engineering': [
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'bim',
        skillName: _t('BIM'),
        skillSearchUrl: '/courses?query=bim',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'structural-engineering',
        skillName: _t('Structural Engineering'),
        skillSearchUrl: '/courses?query=structural%20engineering',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'cnc',
        skillName: _t('CNC'),
        skillSearchUrl: '/courses?query=cnc',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'manufacturing',
        skillName: _t('Manufacturing'),
        skillSearchUrl: '/courses?query=manufacturing',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'cad',
        skillName: _t('CAD'),
        skillSearchUrl: '/courses?query=cad',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'aerospace',
        skillName: _t('Aerospace'),
        skillSearchUrl: '/courses?query=aerospace',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'material-science',
        skillName: _t('Material Science'),
        skillSearchUrl: '/courses?query=material%20science',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'fluid-mechanics',
        skillName: _t('Fluid Mechanics'),
        skillSearchUrl: '/courses?query=fluid%20mechanics',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'additive-manufacturing',
        skillName: _t('Additive Manufacturing'),
        skillSearchUrl: '/courses?query=additive%20manufacturing',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'robotics',
        skillName: _t('Robotics'),
        skillSearchUrl: '/courses?query=robotics',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'machine-design',
        skillName: _t('Machine Design'),
        skillSearchUrl: '/courses?query=machine%20design',
      },
    ],
    'environmental-science-and-sustainability': [
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'renewable-energy',
        skillName: _t('Renewable Energy'),
        skillSearchUrl: '/courses?query=renewable%20energy',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'solar-energy',
        skillName: _t('Solar Energy'),
        skillSearchUrl: '/courses?query=solar%20energy',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'urban-planning',
        skillName: _t('Urban Planning'),
        skillSearchUrl: '/courses?query=urban%20planning',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'climate-change',
        skillName: _t('Climate Change'),
        skillSearchUrl: '/courses?query=climate%20change',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'energy',
        skillName: _t('Energy'),
        skillSearchUrl: '/courses?query=energy',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'gis',
        skillName: _t('GIS'),
        skillSearchUrl: '/courses?query=gis',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'sustainable-development',
        skillName: _t('Sustainable Development'),
        skillSearchUrl: '/courses?query=sustainable%20development',
      },
    ],
    'physics-and-astronomy': [
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'quantum-physics',
        skillName: _t('Quantum Physics'),
        skillSearchUrl: '/courses?query=quantum%20physics',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'space',
        skillName: _t('Space'),
        skillSearchUrl: '/courses?query=space',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'astrobiology',
        skillName: _t('Astrobiology'),
        skillSearchUrl: '/courses?query=astrobiology',
      },
      {
        domainId: 'physical-science-and-engineering',
        skillId: 'thermodynamics',
        skillName: _t('Thermodynamics'),
        skillSearchUrl: '/courses?query=thermodynamics',
      },
    ],
    economics: [
      {
        domainId: 'social-sciences',
        skillId: 'macroeconomics',
        skillName: _t('Macroeconomics'),
        skillSearchUrl: '/courses?query=macroeconomics',
      },
      {
        domainId: 'social-sciences',
        skillId: 'microeconomics',
        skillName: _t('Microeconomics'),
        skillSearchUrl: '/courses?query=microeconomics',
      },
      {
        domainId: 'social-sciences',
        skillId: 'behavioral-economics',
        skillName: _t('Behavioral Economics'),
        skillSearchUrl: '/courses?query=behavioral%20economics',
      },
      {
        domainId: 'social-sciences',
        skillId: 'econometrics',
        skillName: _t('Econometrics'),
        skillSearchUrl: '/courses?query=econometrics',
      },
      {
        domainId: 'social-sciences',
        skillId: 'health-economics',
        skillName: _t('Health Economics'),
        skillSearchUrl: '/courses?query=health%20economics',
      },
      {
        domainId: 'social-sciences',
        skillId: 'environmental-economics',
        skillName: _t('Environmental Economics'),
        skillSearchUrl: '/courses?query=environmental%20economics',
      },
    ],
    education: [
      {
        domainId: 'social-sciences',
        skillId: 'instructional-design',
        skillName: _t('Instructional Design'),
        skillSearchUrl: '/courses?query=instructional%20design',
      },
      {
        domainId: 'social-sciences',
        skillId: 'special-education',
        skillName: _t('Special Education'),
        skillSearchUrl: '/courses?query=special%20education',
      },
      {
        domainId: 'social-sciences',
        skillId: 'adult-education',
        skillName: _t('Adult Education'),
        skillSearchUrl: '/courses?query=adult%20education',
      },
      {
        domainId: 'social-sciences',
        skillId: 'teaching',
        skillName: _t('Teaching'),
        skillSearchUrl: '/courses?query=teaching',
      },
      {
        domainId: 'social-sciences',
        skillId: 'online-teaching',
        skillName: _t('Online Teaching'),
        skillSearchUrl: '/courses?query=online%20teaching',
      },
      {
        domainId: 'social-sciences',
        skillId: 'pedagogy',
        skillName: _t('Pedagogy'),
        skillSearchUrl: '/courses?query=pedagogy',
      },
      {
        domainId: 'social-sciences',
        skillId: 'educational-technology',
        skillName: _t('Educational Technology'),
        skillSearchUrl: '/courses?query=educational%20technology',
      },
      {
        domainId: 'social-sciences',
        skillId: 'early-childhood-education',
        skillName: _t('Early Childhood Education'),
        skillSearchUrl: '/courses?query=early%20childhood%20education',
      },
    ],
    'governance-and-society': [
      {
        domainId: 'social-sciences',
        skillId: 'politics',
        skillName: _t('Politics'),
        skillSearchUrl: '/courses?query=politics',
      },
      {
        domainId: 'social-sciences',
        skillId: 'diplomacy',
        skillName: _t('Diplomacy'),
        skillSearchUrl: '/courses?query=diplomacy',
      },
      {
        domainId: 'social-sciences',
        skillId: 'immigration',
        skillName: _t('Immigration'),
        skillSearchUrl: '/courses?query=immigration',
      },
      {
        domainId: 'social-sciences',
        skillId: 'foreign-policy',
        skillName: _t('Foreign Policy'),
        skillSearchUrl: '/courses?query=foreign%20policy',
      },
      {
        domainId: 'social-sciences',
        skillId: 'policy',
        skillName: _t('Policy'),
        skillSearchUrl: '/courses?query=policy',
      },
      {
        domainId: 'social-sciences',
        skillId: 'government',
        skillName: _t('Government'),
        skillSearchUrl: '/courses?query=government',
      },
    ],
    law: [
      {
        domainId: 'social-sciences',
        skillId: 'criminal-justice',
        skillName: _t('Criminal Justice'),
        skillSearchUrl: '/courses?query=criminal%20justice',
      },
      {
        domainId: 'social-sciences',
        skillId: 'international-law',
        skillName: _t('International Law'),
        skillSearchUrl: '/courses?query=international%20law',
      },
      {
        domainId: 'social-sciences',
        skillId: 'arbitration',
        skillName: _t('Arbitration'),
        skillSearchUrl: '/courses?query=arbitration',
      },
    ],
    'learning-english': [
      {
        domainId: 'language-learning',
        skillId: 'english-writing',
        skillName: _t('English Writing'),
        skillSearchUrl: '/courses?query=english%20writing',
      },
      {
        domainId: 'language-learning',
        skillId: 'english-speaking',
        skillName: _t('English Speaking'),
        skillSearchUrl: '/courses?query=english%20speaking',
      },
      {
        domainId: 'language-learning',
        skillId: 'interview',
        skillName: _t('Interviewing'),
        skillSearchUrl: '/courses?query=interview',
      },
      {
        domainId: 'language-learning',
        skillId: 'business-english',
        skillName: _t('Business English'),
        skillSearchUrl: '/courses?query=business%20english',
      },
      {
        domainId: 'language-learning',
        skillId: 'english-pronunciation',
        skillName: _t('English Pronunciation'),
        skillSearchUrl: '/courses?query=english%20pronunciation',
      },
      {
        domainId: 'language-learning',
        skillId: 'academic-english',
        skillName: _t('Academic English'),
        skillSearchUrl: '/courses?query=academic%20english',
      },
      {
        domainId: 'language-learning',
        skillId: 'tesol',
        skillName: _t('TESOL'),
        skillSearchUrl: '/courses?query=tesol',
      },
    ],
    'other-languages': [
      {
        domainId: 'language-learning',
        skillId: 'japan',
        skillName: _t('Japan'),
        skillSearchUrl: '/courses?query=japan',
      },
      {
        domainId: 'language-learning',
        skillId: 'korean-language',
        skillName: _t('Korean'),
        skillSearchUrl: '/courses?query=korean%20language',
      },
      {
        domainId: 'language-learning',
        skillId: 'mandarin',
        skillName: _t('Mandarin'),
        skillSearchUrl: '/courses?query=mandarin',
      },
    ],
  };
};

export default getSubDomainPopularTopicsData;
